import request from '@/api/request'

// 商户号对账单列表
export const getWxZfbBillListPage = (params) => {
    return request({
        url: 'admin/order/adm/wxZfbBill/getListPage',
        method: 'get',
        params
    })
}

// 平台商户对账单列表
export const getListPageByMchBody = (params) => {
    return request({
        url: 'admin/order/adm/wxZfbBill/getListPageByMchBody',
        method: 'get',
        params,
    })
}